import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import gsap from "gsap";

export const PageTransition = ({ children }) => {
  const ref = useRef(null);
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const el = ref.current;
      const tl = gsap.timeline();
      tl.fromTo(el, { opacity: 0, y: 24, rotateX: 6, transformPerspective: 1200, transformOrigin: "50% 0%" }, { opacity: 1, y: 0, rotateX: 0, duration: 0.55, ease: "power3.out", clearProps: "transform" });
      const cards = el.querySelectorAll(".surface, .stat-3d");
      if (cards.length) tl.fromTo(cards, { opacity: 0, y: 18, rotateX: 12, transformPerspective: 900 }, { opacity: 1, y: 0, rotateX: 0, duration: 0.5, stagger: 0.04, ease: "power2.out", clearProps: "transform,opacity" }, "-=0.35");
    }, ref);
    return () => ctx.revert();
  }, [pathname]);

  return <div ref={ref} className="persp preserve-3d">{children}</div>;
};
